<script setup lang="ts">
import { EditableArea } from "@magnolia/vue-editor";
import { isEditMode } from "~/utils/content/magnolia";
import LoadingElement from "~/templates/elements/LoadingElement.vue";
import MyBritaCheckInComponent from "~/templates/components/account/MyBritaCheckInComponent.vue";

defineProps(["main", "bottom"]);

defineOptions({
  inheritAttrs: false,
});

const { marketSetupLinks } = useMarketSetup();
const { verifyLogIn } = useMyBritaUser();
const showActualContent = ref(false);

onMounted(async () => {
  try {
    if (isEditMode()) {
      // skip verify and login in editmode
      showActualContent.value = true;
      return;
    }
    await verifyLogIn();
    await navigateTo(marketSetupLinks.value?.myBritaOverviewPage);
  } catch (e) {
    showActualContent.value = true;
  }
});
</script>

<template>
  <div>
    <LoadingElement
      v-if="!showActualContent && !isEditMode()"
      class="container col-span-full aspect-3/4 w-full lg:aspect-video"
    />
    <template v-else>
      <EditableArea v-if="main" :content="main" />

      <div class="container my-12 xl:my-24">
        <MyBritaCheckInComponent class="mx-auto md:w-3/4 xl:w-1/2" />
      </div>

      <EditableArea v-if="bottom" :content="bottom" />
    </template>
  </div>
</template>
